import { Component, OnInit } from '@angular/core';
import { GetRecipeResponseDTO } from '../recipe/recipe.dto';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RecipeService } from '../recipe/recipe.service';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-recipelist',
  templateUrl: './recipelist.page.html',
  styleUrls: ['./recipelist.page.scss'],
})
export class RecipelistPage implements OnInit {
  isFav = false;
  isLoading = true;
  loadedRecipes: GetRecipeResponseDTO[];
  allRecipes: GetRecipeResponseDTO[];
  recipesSub: Subscription;
  userId: number;
  default = '/home';
  filter = 'dogs';
  isFavPage = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private recipeService: RecipeService,
    private authService: AuthService,
    private router: Router
  ) { }

  viewFeaturedRecipe() {
    this.router.navigateByUrl('recipe');
  }
  async ngOnInit() {
    this.userId = await this.authService.getUserId();
    this.activatedRoute.queryParams.subscribe((params) => {
      this.isFav = params.fav === 'true';
      if (!this.isFav) {
        this.recipesSub = this.recipeService
          .getAllRecipes()
          .subscribe((res) => {
            this.allRecipes = res;
            this.filter = localStorage.getItem('animalFilter') || 'dogs';
            this.filterRecipes();
            this.isLoading = false;
          });
      } else {
        this.default = '/account';
        this.isFavPage = true;
        this.recipesSub = this.recipeService
          .getFavRecipes(this.userId)
          .subscribe((res) => {
            this.loadedRecipes = res;
            this.isLoading = false;
          });
      }
    });
  }

  filterRecipes() {
    if (this.filter === 'dogs') {
      this.loadedRecipes = this.allRecipes.filter(
        (recipe) => recipe.petTypeId === 1
      );
      localStorage.setItem('animalFilter', this.filter);
    } else if (this.filter === 'cats') {
      this.loadedRecipes = this.allRecipes.filter(
        (recipe) => recipe.petTypeId === 2
      );
      localStorage.setItem('animalFilter', this.filter);
    } else {
      this.loadedRecipes = this.allRecipes;
    }
  }
}



